<template>
  <div 
    class="fill-height">
    <v-layout wrap>
      <v-flex>
        <section>
          <v-row
            class="mb-4">
            <v-col
              cols="12">
              <div
                class="d-flex align-center">
                <div
                  class="d-flex align-center">
                  <v-avatar
                    tile
                    size="30">
                    <v-img
                      contain
                      alt="amanata"  
                      :src="require('@/assets/image/grip_menu.png')">
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height"
                          align="center"
                          justify="center">
                          <v-progress-circular 
                            size="20"
                            indeterminate 
                            :color="set_color">
                          </v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </v-avatar>

                  <span
                    class="title black--text ml-2"
                    style="font-weight: 600;">
                    Personal
                  </span>
                </div>
              </div>
            </v-col>
          </v-row>

          <v-row>
            <v-col
              cols="12"
              md="6"
              class="pt-0">
              <ValidationProvider 
                name="Nama Lengkap" 
                rules="required" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  <span class="red--text">*</span>

                  Nama Lengkap
                </div>

                <v-text-field
                  v-on:keyup.enter="save()"
                  
                  filled
                  rounded
                  dense

                  :color="set_color"
                  placeholder="Contoh. John Doe"

                  hide-details

                  v-model="form.name"
                  :success="valid"
                  :error-messages="errors"
                  required
                  style="border-radius: 10px;">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        {{ errors[0] }}
                      </v-tooltip>
                    </div>
                    
                    <div v-if="form.name !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-row>
            <v-col
              cols="12"
              md="6">
              <ValidationProvider 
                name="Username" 
                rules="required" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  <span class="red--text">*</span>

                  Username
                </div>

                <v-text-field
                  v-on:keyup.enter="save()"
                  
                  filled
                  rounded
                  dense

                  :color="set_color"
                  placeholder="Contoh. johndoe"

                  hide-details

                  v-model="form.username"
                  :success="valid"
                  :error-messages="errors"
                  required
                  style="border-radius: 10px;">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        {{ errors[0] }}
                      </v-tooltip>
                    </div>
                    
                    <div v-if="form.username !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>
            </v-col>

            <v-col
              cols="12"
              md="6">
              <ValidationProvider 
                name="Nomor Induk Pegawai" 
                rules="required" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  <span class="red--text">*</span>

                  Nomor Induk Pegawai
                </div>

                <v-text-field
                  v-on:keyup.enter="save()"
                  
                  filled
                  rounded
                  dense

                  onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                  type="number"
                  min="0"

                  :color="set_color"
                  placeholder="Contoh. 0001"

                  hide-details

                  @blur="fetchCheck()"

                  v-model="form.code"
                  :success="valid"
                  :error-messages="errors"
                  required
                  style="border-radius: 10px;">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form.code !== '' && message.check.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Nomor Induk Pegawai {{ message.check }}
                      </v-tooltip>
                    </div>
                    
                    <div v-if="form.code !== '' && valid && message.check.length < 1">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-row>
            <v-col
              cols="12"
              md="6">
              <ValidationProvider 
                name="Email" 
                rules="required|email" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  <span class="red--text">*</span>

                  Email
                </div>

                <v-text-field
                  v-on:keyup.enter="save()"
                  
                  filled
                  rounded
                  dense

                  :color="set_color"
                  placeholder="Contoh. XXXX@gmail.com"

                  hide-details

                  v-model="form.email"
                  :success="valid"
                  :error-messages="errors"
                  required
                  style="border-radius: 10px;">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        {{ errors[0] }}
                      </v-tooltip>
                    </div>
                    
                    <div v-if="form.email !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>
            </v-col>

            <v-col
              cols="12"
              md="6">
              <ValidationProvider 
                name="Mobilephone" 
                rules="required|min:10|max:13" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  <span class="red--text">*</span>

                  Mobilephone
                </div>

                <v-text-field
                  v-on:keyup.enter="save()"
                  
                  filled
                  rounded
                  dense

                  onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                  type="number"
                  min="0"

                  :color="set_color"
                  placeholder="Contoh. 081XXXXXXXXX"

                  hide-details

                  v-model="form.mobilephone"
                  :success="valid"
                  :error-messages="errors"
                  required
                  style="border-radius: 10px;">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        {{ errors[0] }}
                      </v-tooltip>
                    </div>
                    
                    <div v-if="form.mobilephone !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-divider
            class="my-4"
            style="border-top: 2px dashed #EBEBEB;" />

          <v-row>
            <v-col
              cols="12"
              md="6">
              <ValidationProvider 
                name="Unit / Divisi" 
                rules="required"
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  <span class="red--text">*</span>
                  
                  Unit / Divisi
                </div>

                <v-select
                  v-on:keyup.enter="save()"

                  :disabled="$route.query.unit_id !== undefined"
                  
                  filled
                  rounded
                  dense

                  :color="set_color"
                  placeholder="Contoh. Kantor Pusat SDM"

                  hide-details

                  :items="unit"
                  item-text="name"
                  item-value="id"
                  :item-color="set_color"

                  @change="form.position_id = ''; form.position = ''; fetchPosition();"

                  v-model="form.unit_id"
                  :success="valid"
                  :error-messages="errors"
                  required
                  style="border-radius: 10px;">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        {{ errors[0] }}
                      </v-tooltip>
                    </div>
                    
                    <div v-if="form.unit_id !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-select>
              </ValidationProvider>
            </v-col>

            <v-col v-if="form.role !== 'superadmin'"
              cols="12"
              md="6">
              <ValidationProvider 
                name="Jabatan" 
                rules="required"
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  <span class="red--text">*</span>
                  
                  Jabatan 
                </div>

                <v-select
                  v-on:keyup.enter="save()"
                  
                  filled
                  rounded
                  dense

                  :disabled="form.unit_id === ''"

                  :color="set_color"
                  placeholder="Contoh. Marketing"

                  hide-details

                  :items="position"
                  item-text="title"
                  item-value="id"
                  :item-color="set_color"

                  v-model="form.position_id"
                  :success="valid"
                  :error-messages="errors"
                  required
                  style="border-radius: 10px;">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        {{ errors[0] }}
                      </v-tooltip>
                    </div>
                    
                    <div v-if="form.position_id !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-select>
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-row v-if="form.role !== 'superadmin'">
            <v-col
              cols="12"
              md="6">
              <ValidationProvider 
                name="Level Jabatan" 
                rules="required"
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  <span class="red--text">*</span>

                  Level Jabatan
                </div>

                <v-select
                  v-on:keyup.enter="save()"
                  
                  filled
                  rounded
                  dense

                  :color="set_color"
                  placeholder="Contoh. Staff"

                  hide-details

                  :items="[
                    {
                      text: 'Staff',
                      value: 'staff'
                    },
                    {
                      text: 'Admin',
                      value: 'admin'
                    }
                  ]"
                  item-text="text"
                  item-value="value"
                  :item-color="set_color"

                  v-model="form.role"
                  :success="valid"
                  :error-messages="errors"
                  required
                  style="border-radius: 10px;">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        {{ errors[0] }}
                      </v-tooltip>
                    </div>
                    
                    <div v-if="form.role !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-select>
              </ValidationProvider>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  export default {
    props: {
      form: {
        type: Object,
        default: {}
      }
    },
    data () {
      return {
        unit: [],
        position: [],

        picker: {
          join: false
        },

        message: {
          check: ''
        }
      }
    },
    components: {
      
    },
    watch: {
      'form.position_id': function() {
        let self = this
        let data = this.position.filter(function(v) {
          return self.form.position_id == v.id
        })

        if (data.length > 0) {
          this.form.position = data[0].title
        }
      }
    },
    computed: {
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      }
    },
    mounted () {
      this.fetchUnit()
    },
    methods: {
      async fetchUnit () {
        let params = {
          limit: 100000
        }

        await get('admin/unit/data', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.unit = res.results.data
            
            if (this.$route.query.unit_id !== undefined) this.form.unit_id = this.$route.query.unit_id

            this.fetchPosition()
          }
        })
      },

      async fetchPosition () {
        let params = {
          limit: 100000,
          unit_id: this.form.unit_id,

          par_id: this.$route.params.id === undefined && this.$route.query.position_id !== undefined ? this.$route.query.position_id : ''
        }

        await get('admin/user_position/data', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.position = res.results.data
          }
        })
      },

      async fetchCheck () {
        let params = {
          search: this.form.code
        }

        await get('admin/user/data', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            let total = res.results.data.length

            this.message.check = total > 0 ? 'sudah digunakan' : ''
          }
        })
      }
    }
  }
</script>